/**
 * Drop / remap edges whose endpoints are missing so Cytoscape never throws
 * "nonexistent source" when a counterparty node was skipped. Also bind
 * mixed-case EVM ids onto the node that already exists.
 *
 * Nodes are emitted before edges — cy.add / cy.json process in array order.
 */
function isEdge(el: any): boolean {
    if (!el?.data) return false;
    if (el.group === 'edges') return true;
    if (el.group === 'nodes') return false;
    return Boolean(el.data.source);
}

function lookupNodeId(nodeById: Map<string, string>, raw: unknown): string | undefined {
    if (raw == null || raw === '') return undefined;
    const sid = String(raw);
    return nodeById.get(sid) || nodeById.get(sid.toLowerCase());
}

export function cytoscapeSafeElements(elements: any[]): any[] {
    const nodes: any[] = [];
    const edges: any[] = [];
    for (const el of elements || []) {
        if (!el?.data) continue;
        if (isEdge(el)) edges.push(el);
        else nodes.push(el);
    }

    const nodeById = new Map<string, string>();
    for (const el of nodes) {
        const id = el?.data?.id;
        if (!id) continue;
        const sid = String(id);
        nodeById.set(sid, sid);
        nodeById.set(sid.toLowerCase(), sid);
    }

    const out: any[] = [];
    for (const el of nodes) {
        const parent = el.data.parent;
        if (parent) {
            const resolved = lookupNodeId(nodeById, parent);
            if (!resolved) {
                const { parent: _drop, ...rest } = el.data;
                out.push({ ...el, data: rest });
                continue;
            }
            if (resolved !== parent) {
                out.push({ ...el, data: { ...el.data, parent: resolved } });
                continue;
            }
        }
        out.push(el);
    }

    for (const el of edges) {
        const src = lookupNodeId(nodeById, el.data.source);
        const tgt = lookupNodeId(nodeById, el.data.target);
        if (!src || !tgt) continue;
        if (src === el.data.source && tgt === el.data.target) {
            out.push(el);
        } else {
            out.push({ ...el, data: { ...el.data, source: src, target: tgt } });
        }
    }
    return out;
}
